import React, { Component } from "react"
import { connect } from "react-redux";
import { AppState } from "src/store";
import "./Landing.css"

interface HomeProps {
    userSettings: any
    roles: AppState["user"]["roles"]
}

interface HomeState {

}

class Landing extends Component<HomeProps, HomeState> {

    render() {

        const props = this.props
        let accountNeeedsAttention = false

        if(!props.roles || props.roles.length < 2){
            accountNeeedsAttention = true
        }

        return (
            <div className="Landing">
                {accountNeeedsAttention && <div className="LandingAccountNeedsAttention">
                    <p>Please contact the Helpdesk for assistance.</p>
                    <a href="tel:+14063272011">(406) 327-2011</a>
                    <br></br>
                    <br></br>
                    <a href="mailto:elmhelpdesk@elmutility.com">elmhelpdesk@elmutility.com</a>
                </div>}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userSettings: state.user.UserSettings,
    roles: state.user.roles
})

export default connect(mapStateToProps)(Landing)